import { Caption, Flex, useAppDisplayModeContext } from '@archipro-design/aria';
import { useStyles } from '@archipro-design/aria';
import type { DesignBoardWithDetailedPinsFragment } from 'generated/graphql';
import { pluralize } from '~/utils';
import * as S from './BoardDetailFilter.style';
import { ArrowLeftSLine, CustomLock } from '@archipro-design/icons';
import { BoardDetailFilterNav } from '~/modules/design-board/component/mobile-filter-nav/BoardDetailFilterNav';
import FilterBar from '~/modules/design-board/component/board-detail/FilterBar';
import { Link } from '@remix-run/react';
import type { SideNavItems } from '../../type/design-board-types';

interface BoardDetailFilterProps {
    board: DesignBoardWithDetailedPinsFragment;
    pinCountAfterUpload?: number;
    backItem: SideNavItems;
}

const BoardDetailFilter = ({
    board,
    pinCountAfterUpload,
    backItem,
}: BoardDetailFilterProps) => {
    const { css } = useStyles();
    const { mobile } = useAppDisplayModeContext();
    const pinCount = pinCountAfterUpload || board.PinsCount;

    return mobile ? (
        <BoardDetailFilterNav pinCount={pinCount} />
    ) : (
        <>
            <Flex className={css(S.BaseStyle)} column={false}>
                <Flex className={css(S.BackBtnWrap)}>
                    <Caption
                        as={Link}
                        to={backItem.link}
                        prefetch="intent"
                        variant={'02'}
                        weight={'medium'}
                    >
                        <ArrowLeftSLine />
                        {backItem.title}
                    </Caption>
                </Flex>
                <Caption className={css(S.Header)}>{board.Title}</Caption>
                <Flex className={css(S.PinAndFollower)}>
                    {!board.Public && <CustomLock />}
                    <Caption>
                        {pluralize(pinCount, 'pin')}
                        {board.Public &&
                            ` - ${pluralize(board.FollowersCount, 'follower')}`}
                    </Caption>
                </Flex>
                <div>
                    <FilterBar board={board} />
                </div>
            </Flex>
        </>
    );
};

export default BoardDetailFilter;
